var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeatport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 15.3505C18.8569 17.9219 16.8049 20 14.2074 20C11.636 20 9.58408 17.9742 9.58408 15.3505C9.58408 14.1171 10.0516 13.026 10.7918 12.2079L7.64911 15.3505L6 13.7014L9.54551 10.1949C10.0259 9.71447 10.2728 9.09091 10.2728 8.40264V4H12.5973V8.40264C12.5973 9.75347 12.1169 10.896 11.1818 11.8311L11.0776 11.9353C11.8958 11.1819 13.0126 10.7276 14.2074 10.7276C16.8439 10.7272 18.8569 12.8181 18.8569 15.3505ZM16.7531 15.3505C16.7531 13.974 15.6101 12.8571 14.2074 12.8571C12.7919 12.8571 11.6879 14.0258 11.6879 15.3505C11.6879 16.7142 12.8047 17.87 14.2074 17.87C15.662 17.87 16.7531 16.6881 16.7531 15.3505Z",
    fill: "#01FF95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatport);
export default __webpack_public_path__ + "static/media/beatport.55c7f6ac73fd7d0757b986804ef0fece.svg";
export { ForwardRef as ReactComponent };